// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__3sn7_","large":"styles_large__Qz35h"};